var _circle, _circle2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    fill: "#12121F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 19,
    fill: "#080815",
    stroke: "url(#paint0_linear_74_894)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 27.2188C22 27.051 22.0641 26.883 22.1922 26.7548L28.7547 20.1923C29.0112 19.9359 29.4264 19.9359 29.6827 20.1923C29.9389 20.4488 29.9391 20.864 29.6827 21.1203L23.5841 27.2188L29.6827 33.3173C29.9391 33.5738 29.9391 33.989 29.6827 34.2453C29.4262 34.5015 29.011 34.5017 28.7547 34.2453L22.1922 27.6828C22.0641 27.5546 22 27.3866 22 27.2188Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_74_894",
    x1: 26.5,
    y1: 7,
    x2: 26.5,
    y2: 46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001EFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavPrev);
export default __webpack_public_path__ + "static/media/nav-prev.a9880d93682bc0d521bedd775bd3df22.svg";
export { ForwardRef as ReactComponent };